import Clickme from 'src/components/Clickme';
import { useSelector } from 'src/hooks/useSelector';

export const MIN_VACANCIES_COUNT_FOR_BANNER_UNDER_RESULTS = 20;

const BannersUnderResult = ({ countVacancies }) => {
    const banners = useSelector((state) => state.banners);
    if (countVacancies < MIN_VACANCIES_COUNT_FOR_BANNER_UNDER_RESULTS) {
        return null;
    }
    const bannersSML = banners['under-search-results-rotate'];
    const bannersXS = banners['under-search-results-xs'];
    return (
        <>
            {bannersSML?.length > 0 && (
                <Clickme banners={bannersSML} groupClassNames="serp-special serp-special_under-results" />
            )}
            {bannersXS?.length > 0 && (
                <Clickme
                    banners={bannersXS}
                    groupClassNames="serp-special serp-special_under-results serp-special_under-results-xs-only"
                />
            )}
        </>
    );
};

export default BannersUnderResult;
